module.exports = __webpack_public_path__ + "img/bg-pattern.0dfe077b.svg";